<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="mck">N</span>
          <input type="text" placeholder="Търсене" v-model="search" />
          <span class="mck modal-close" @click="close()">F</span>
        </div>
        <div class="btns-select">
          <button class="btn btn-select" @click="toggleUsers(true)">
            <span class="mck">W</span>
            Всички
          </button>
          <button class="btn btn-select" @click="toggleUsers(false)">
            <span class="mck">X</span>
            Никой
          </button>
        </div>
      </div>
      <div class="modal-content">
        <div
          class="modal-content-check"
          v-for="i in filteredInventories"
          :key="`addInventoriesModal-${i._id}`"
        >
          <label class="checkbox-wrapper">
            {{ getInventoryName(i) }}
            <input
              type="checkbox"
              :id="i._id"
              v-model="i.isSelected"
              :disabled="i.isDisabled"
            />
            <span class="checkmark"></span>
          </label>
        </div>
        <!-- NO RESULTS -->
        <p
          class="modal-content-no-results"
          v-if="inventories.length && !filteredInventories.length"
        >
          <template v-if="search">
            Няма намерени резултати за '
            <strong>{{ this.search }}</strong
            >'
          </template>
          <template v-else>Няма намерени резултати</template>
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-new" @click="save()" :disabled="loading">
          <span class="mck">Y</span>
          Запази
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["ids"],
  data() {
    return {
      inventories: [],
      dropdownActive: false,
      search: "",
      loading: false,
    };
  },
  watch: {
    active(to) {
      if (to === "positions") {
        this.getPositions();
      } else if (to === "groups") {
        this.getGroups();
      }
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
    filteredInventories() {
      return this.inventories.filter((i) => {
        return (
          i.name.toLowerCase().includes(this.search.toLowerCase()) ||
          i.brand.toLowerCase().includes(this.search.toLowerCase()) ||
          i.serialNumber.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
  },
  methods: {
    getInventories() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/inventory/free`)
        .then((response) => {
          this.inventories = response.data;

          this.$store.dispatch("stopLoading");
        });
    },
    toggleUsers(toggle) {
      // If searching or filtered select only results
      if (this.search.length) {
        const tempFilteredInventories = this.filteredInventories;
        this.inventories.forEach((i, index) => {
          tempFilteredInventories.forEach((fi) => {
            if (fi._id === i._id) {
              let inventory = i;
              inventory.isSelected = toggle;

              this.$set(this.inventories, index, inventory);
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.inventories.forEach((i, index) => {
          let inventory = i;
          inventory.isSelected = toggle;

          this.$set(this.inventories, index, inventory);
        });
      }
    },
    getInventoryName(i) {
      return [i.name, i.brand, i.serialNumber].filter((x) => x).join(" - ");
    },
    getSelectedInventories() {
      return this.inventories.filter((i) => {
        return i.isSelected;
      });
    },
    close() {
      this.$emit("close");
    },
    async save() {
      this.loading = true;
      const promises = [];
      const si = this.getSelectedInventories();

      for (let i of si) {
        // if (u.isSelected && !u.part) {
        //   return this.$snotify.error(
        //     "Трябва да изберете част за всеки избран работник"
        //   );
        // }

        promises.push(
          new Promise((res, rej) => {
            i.bulk = true;
            i.status = "onsite";
            i.location = {
              company: this.ids.company,
              project: this.ids.project,
              reporter: this.getUser._id,
            };

            const fd = new FormData();
            fd.append("data", JSON.stringify(i));

            this.$http
              .put(`${process.env.VUE_APP_BASE_URI}/inventory`, fd)
              .then(() => {
                console.log("??");
                this.$snotify.success("Успешно избрахте локация на инвентар!");
                res();
              })
              .catch((error) => {
                if (typeof error.response.data === "string") {
                  rej(error.response.data);
                } else {
                  console.log(error.response);
                  rej("Нещо се обърка! Моля опитайте отново.");
                }
              });
          })
        );
      }

      try {
        await Promise.all(promises);
        this.close();
      } catch (err) {
        console.log(err);
        this.$snotify.error(err);
        this.loading = false;
      }
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        // this.save();
      } else if (e.code === "Escape") {
        this.close();
      }
    },
  },
  mounted() {
    this.getInventories();
    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.modal-header {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.new-input {
  position: relative;
}
.new-input .modal-close {
  left: initial;
  right: 3px;
}
/* Responsive */
.modal-header .btns-select .btn:not(:first-child) {
  width: initial;
}
.filter-toggle {
  justify-content: flex-start;
  overflow: hidden;
  position: relative;
}
.filter-toggle .mck,
.filter-toggle .mck2 {
  margin-right: 10px;
}
.filter-toggle--active {
  overflow: initial;
}
.filter-toggle span:not(.mck):not(.mck2) {
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-p {
  border-radius: 4px;
  cursor: pointer;
  padding: 10px;
  transition: all 0.3s;
}
.select-p:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.btns-select {
  margin: 0;
}
.btn-select {
  height: 35px;
}
.btn-select:disabled {
  cursor: default;
  opacity: 0.5;
}
.modal-content-check {
  align-items: center;
}
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  /* .modal-header .new-input {
    width: 72%;
  } */
}
@media screen and (max-width: 600px) {
  /* .modal-content-check {
    width: 45%;
  } */
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
